import { segmentLength, rumbleLength } from './constants';

//=========================================================================
// general purpose helpers (mostly math)
//=========================================================================

export const Util = {
  timestamp: function () {
    return new Date().getTime();
  },
  toInt: function (obj: any, def: any): any {
    if (obj !== null) {
      var x = parseInt(obj, 10);
      if (!isNaN(x)) return x;
    }
    return Util.toInt(def, 0);
  },
  toFloat: function (obj: any, def: any): number {
    if (obj !== null) {
      var x = parseFloat(obj);
      if (!isNaN(x)) return x;
    }
    return Util.toFloat(def, 0.0);
  },
  limit: function (value: any, min: any, max: any) {
    return Math.max(min, Math.min(value, max));
  },
  randomInt: function (min: any, max: any) {
    return Math.round(Util.interpolate(min, max, Math.random()));
  },
  randomChoice: function (options: any) {
    return options[Util.randomInt(0, options.length - 1)];
  },
  percentRemaining: function (n: any, total: any) {
    return (n % total) / total;
  },
  accelerate: function (v: any, accel: any, dt: any) {
    return v + accel * dt;
  },
  interpolate: function (a: any, b: any, percent: any) {
    return a + (b - a) * percent;
  },
  easeIn: function (a: any, b: any, percent: any) {
    return a + (b - a) * Math.pow(percent, 2);
  },
  easeOut: function (a: any, b: any, percent: any) {
    return a + (b - a) * (1 - Math.pow(1 - percent, 2));
  },
  easeInOut: function (a: any, b: any, percent: any) {
    return a + (b - a) * (-Math.cos(percent * Math.PI) / 2 + 0.5);
  },
  exponentialFog: function (distance: any, density: any) {
    return 1 / Math.pow(Math.E, distance * distance * density);
  },

  increase: function (start: any, increment: any, max: any) {
    // with looping
    var result = start + increment;
    while (result >= max) result -= max;
    while (result < 0) result += max;
    return result;
  },

  project: function (
    p: any,
    cameraX: any,
    cameraY: any,
    cameraZ: any,
    cameraDepth: any,
    width: any,
    height: any,
    roadWidth: any
  ) {
    p.camera.x = (p.world.x || 0) - cameraX;
    p.camera.y = (p.world.y || 0) - cameraY;
    p.camera.z = (p.world.z || 0) - cameraZ;
    p.screen.scale = cameraDepth / p.camera.z;
    p.screen.x = Math.round(width / 2 + (p.screen.scale * p.camera.x * width) / 2);
    p.screen.y = Math.round(height / 2 - (p.screen.scale * p.camera.y * height) / 2);
    p.screen.w = Math.round((p.screen.scale * roadWidth * width) / 2);
  },

  overlap: function (x1: any, w1: any, x2: any, w2: any, percent: any) {
    var half = (percent || 1) / 2;
    var min1 = x1 - w1 * half;
    var max1 = x1 + w1 * half;
    var min2 = x2 - w2 * half;
    var max2 = x2 + w2 * half;
    return !(max1 < min2 || min1 > max2);
  },
};

//=========================================================================
// BUILD ROAD GEOMETRY
//=========================================================================

export function addSegment(curve: any, y: any, COLORS: any, segments: any[]) {
  var n = segments.length;
  segments.push({
    index: n,
    p1: { world: { y: lastY(segments), z: n * segmentLength }, camera: {}, screen: {} },
    p2: { world: { y: y, z: (n + 1) * segmentLength }, camera: {}, screen: {} },
    curve: curve,
    sprites: [],
    cars: [],
    color: Math.floor(n / rumbleLength) % 2 ? COLORS.DARK : COLORS.LIGHT,
  });
}

export function addRoad(enter: any, hold: any, leave: any, curve: any, y: any, COLORS: any, segments: any[]) {
  var startY = lastY(segments);
  var endY = startY + Util.toInt(y, 0) * segmentLength;
  var n,
    total = enter + hold + leave;
  for (n = 0; n < enter; n++)
    addSegment(Util.easeIn(0, curve, n / enter), Util.easeInOut(startY, endY, n / total), COLORS, segments);
  for (n = 0; n < hold; n++) addSegment(curve, Util.easeInOut(startY, endY, (enter + n) / total), COLORS, segments);
  for (n = 0; n < leave; n++)
    addSegment(
      Util.easeInOut(curve, 0, n / leave),
      Util.easeInOut(startY, endY, (enter + hold + n) / total),
      COLORS,
      segments
    );
}

export function addSprite(n: any, sprite: any, offset: any, segments: any) {
  segments[n].sprites.push({ source: sprite, offset: offset });
}

export function lastY(segments: any[]) {
  return segments.length === 0 ? 0 : segments[segments.length - 1].p2.world.y;
}

export function formatTime(dt: number) {
  var minutes = Math.floor(dt / 60);
  var seconds = Math.floor(dt - minutes * 60);
  var tenths = Math.floor(10000 * (dt - Math.floor(dt)));
  if (minutes > 0) {
    return minutes + '.' + (seconds < 10 ? '0' : '') + seconds + '.' + tenths;
  } else {
    return seconds + '.' + tenths;
  }
}
